/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'

function Post() {

const articlesData = [
    {
      "imageSrc": "https://miro.medium.com/v2/resize:fill:224:224/1*gTayU4NSJKFnzGaHmYLnOg.png",
      "title": "實戰指南：用ChatGPT-Plugin 打造您的首個智能Todolist！",
      "url":"",
      "date": "June 1, 2020",
      "views": "2.1K views"
    },
    {
      "imageSrc": "https://miro.medium.com/v2/resize:fill:224:224/1*yU5yTFSqHX85XOdFU6T8rw.png",
      "title": "用Poe製作獨一無二的ChatGPT Bot, hohoGPT登場",
      "url":"",
      "date": "June 2, 2020",
      "views": "2.2K views"
    },
    {
      "imageSrc": "https://source.unsplash.com/200x200/?fashion?3",
      "title": "Jarvis就要來了，使用GPT-4的AutoGPT全面解析",
      "url":"",
      "date": "June 3, 2020",
      "views": "2.3K views"
    },
    {
      "imageSrc": "https://source.unsplash.com/200x200/?fashion?4",
      "title": "【ChatPaper教學】如何通過ChatGPT技術進行論文閱讀、總結和修改？",
      "url":"",
      "date": "June 4, 2020",
      "views": "2.4K views"
    }
  ]
  
  return (
<section className="py-6 sm:py-12 dark:bg-gray-800 dark:text-gray-100">
  <div className="container p-6 mx-auto space-y-8">
    {/* ... */}
    <div className="grid grid-cols-1 gap-x-4 gap-y-8 md:grid-cols-2 lg:grid-cols-4">
      {articlesData.map((article, index) => (
        <article key={index} className="flex flex-col dark:bg-gray-900">
          <a rel="noopener noreferrer" href="#" aria-label="Te nulla oportere reprimique his dolorum">
            <img alt="" className="object-cover w-full h-52 dark:bg-gray-500" src={article.imageSrc} />
          </a>
          <div className="flex flex-col flex-1 p-6">
            <a rel="noopener noreferrer" href="#" aria-label="Te nulla oportere reprimique his dolorum"></a>
            <a rel="noopener noreferrer" href="#" className="text-xs tracki uppercase hover:underline text-violet-400 text-decoration-none">
              Convenire
            </a>
            <h3 className="flex-1 py-2 text-lg font-semibold leadi">{article.title}</h3>
            {/* <div className="flex flex-wrap justify-between pt-3 space-x-2 text-xs dark:text-gray-400">
              <span>{article.date}</span>
              <span>{article.views}</span>
            </div> */}
          </div>
        </article>
      ))}
    </div>
  </div>
</section>
  )
}

export default Post